import omit from 'lodash/omit';
import BaseImage, { ImageProps as NextImageProps } from 'next/image';
import { ComponentProps, FC } from 'react';

interface ImageProps extends NextImageProps {}

export const Image: FC<ImageProps> = ({ src, alt, ...props }) => {
  // Replace static.kidsplaza.vn with localhost:6006 in local environment
  const getLocalSrc = (originalSrc: ComponentProps<typeof BaseImage>['src']): ComponentProps<typeof BaseImage>['src'] => {
    // Check if running in development/local environment
    const isLocal =
      process.env.NODE_ENV === 'development' ||
      (typeof window !== 'undefined' && window.location.hostname === 'localhost');

    if (isLocal && typeof originalSrc === 'string' && originalSrc.includes('static.kidsplaza.vn')) {
      return originalSrc.replace('https://static.kidsplaza.vn/', 'https://static.kidsplaza.vn/');
    }

    return originalSrc;
  };

  return <BaseImage src={getLocalSrc(src)} alt={alt} {...props} unoptimized />;
};

const customLoader = ({ src, width, quality }: { src: string; width: number; quality?: number }) => {
  const isSslHttp = src.startsWith('http') || src.startsWith('https');
  const shopUrl = process.env.NEXT_PUBLIC_BASE_SHOP_URL_ENDPOINT?.replace(/\/$/, '');
  const finalSrc = isSslHttp ? src : `${shopUrl}/${src}`;

  // Validate image type
  const allowedImageTypes = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
  const url = new URL(finalSrc);
  const extension = url.pathname.split('.').pop()?.toLowerCase() ?? '';

  if (!allowedImageTypes.includes(extension)) {
    return src;
  }

  // Convert to WebP format
  return `https://cdn.kidsplaza.vn/_next/image?url=${encodeURIComponent(finalSrc)}&w=${width}&q=${
    quality || 100
  }&fm=webp`;
};

// export const ImageOptimized: FC<ImageProps> = ({ src, alt, ...props }) => {
//   return <BaseImage src={src} alt={alt} loader={customLoader} {...props} />;
// };
export const ImageOptimized: FC<ImageProps> = ({ src, alt, ...props }) => {
  // Replace static.kidsplaza.vn with localhost:6006 in local environment
  const getLocalSrc = (originalSrc: ComponentProps<typeof BaseImage>['src']): ComponentProps<typeof BaseImage>['src'] => {
    // Check if running in development/local environment
    const isLocal =
      process.env.NODE_ENV === 'development' ||
      (typeof window !== 'undefined' && window.location.hostname === 'localhost');

    if (isLocal && typeof originalSrc === 'string' && originalSrc.includes('static.kidsplaza.vn')) {
      return originalSrc.replace('https://static.kidsplaza.vn/', 'https://static.kidsplaza.vn/');
    }

    return originalSrc;
  };

  return <BaseImage src={getLocalSrc(src)} alt={alt} {...props} unoptimized />;
};
